/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "@hooks/useDevice";
import { useRouter } from "expo-router";
import { useEffect, useState } from "react";

/* -----------------Types--------------- */
import type { ExamDetails } from "@memorang/types/src/exams";
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";
import { fetchExamDetails } from "api/commerce/exam-service";
import type { ApplyAccessCodeResponse } from "api/commerce/types";
/* -----------------Child components--------------- */
import RedeemCodeSuccessView from "./RedeemCodeSuccessView";

const getProductsMapping = (accessCodeResult: ApplyAccessCodeResponse) => {
	return accessCodeResult.productData && accessCodeResult.productData.length > 1
		? accessCodeResult.productData.map((product) => {
				return {
					icon: product.icon,
					title: product.bundleName,
					id: product.bundleId,
					description:
						product.bundleType === "PRACTICE_TEST"
							? "Practice Test"
							: "Study-Pack",
					features: product.features,
					isCustomAccess: product.isCustomAccess,
					examId: product.examId,
					bundleType: product.bundleType,
					beginStartDate: product.beginStartDate,
					endStartDate: product.endStartDate,
				};
			})
		: [
				{
					icon: accessCodeResult.data.icon,
					title: accessCodeResult.data.bundleName,
					id: accessCodeResult.data.bundleId,
					description:
						accessCodeResult.data.bundleType === "STUDY_PACK"
							? "Study-Pack"
							: "Practice Test",
					features: accessCodeResult.data.features,
					isCustomAccess: accessCodeResult.data.isCustomAccess,
					examId: accessCodeResult.data.examId,
					bundleType: accessCodeResult.data.bundleType,
					beginStartDate: accessCodeResult.data.beginStartDate,
					endStartDate: accessCodeResult.data.endStartDate,
				},
			];
};

const RedeemCodeSuccessContainer = ({
	accessCodeResult,
}: { accessCodeResult: ApplyAccessCodeResponse }) => {
	const { isMobile } = useDevice();

	const router = useRouter();
	const [examDetails, setExamDetails] = useState<ExamDetails | null>(null);

	const [showFreeQuizDialog, setShowFreeQuizDialog] = useState(false);

	const examId = accessCodeResult.data.examId;

	const handleNavigateToProduct = () => {
		if (examDetails) {
			const hasPracticeTests = accessCodeResult.productData?.find(
				(item) => item.bundleType === "PRACTICE_TEST",
			);
			const url =
				!hasPracticeTests || isMobile ? "/study-pack" : "/practice-tests";
			router.push(url);
		}
	};
	const handleCloseFreeQuizDialog = (navigate?: boolean) => {
		setShowFreeQuizDialog(false);
		if (navigate) {
			handleNavigateToProduct();
		}
	};

	useEffect(() => {
		if (examId) {
			fetchExamDetails({
				examId: examId!,
			}).then((response) => setExamDetails(response));
		}
	}, [examId]);

	if (!(accessCodeResult && examDetails)) {
		return (
			<Box height="100%">
				<Loader />
			</Box>
		);
	}

	const title = "Access Granted";
	const products = getProductsMapping(accessCodeResult);

	return (
		<RedeemCodeSuccessView
			examName={examDetails?.exam.name || ""}
			products={products}
			title={title}
			showFreeQuizDialog={showFreeQuizDialog}
			handleCloseFreeQuizDialog={handleCloseFreeQuizDialog}
			examDetails={examDetails}
		/>
	);
};

export default RedeemCodeSuccessContainer;
